import * as z from "zod/v4";
import { literal, nativeEnum } from "zod/v4";
import { ContentType, OrderAvailableToTrack } from "../../conversation";
import { BaseMessageDbParser } from "../base-conversation-message-db-parser";
import { AutoGeneratedFieldsSchema } from "../message-parser-utils";
const CheckOrderTrackingInfoOutputParser = nativeEnum(OrderAvailableToTrack);
export type CheckOrderTrackingInfoOutput = z.infer<
  typeof CheckOrderTrackingInfoOutputParser
>;

//TODO I think we can remove this
/**
 * @deprecated Order tracking tool removed on 01/22/2025. Deprecated in favor
 * of TrackOrderUiMessageSchema.
 */
const CheckOrderTrackingInfoMessageSchema = BaseMessageDbParser.extend({
  contentType: literal(ContentType.TOOL_CALL_TRACK_ORDER_AVAILABLE),
  structuredContent: CheckOrderTrackingInfoOutputParser.optional(),
});

export const CheckOrderTrackingInfoDbParser =
  CheckOrderTrackingInfoMessageSchema.merge(AutoGeneratedFieldsSchema);
